import React, { useEffect, useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import EditLicence from "./EditLicence";

const STORAGE_KEY = "ACTIVE_LICENSE_ID";
const STORAGE_TAB_KEY = "ACTIVE_LICENSE_TAB_ID";

const AdminLicensePage = () => {
  const location = useLocation();
  const [params] = useSearchParams();

  // Query'den gelenler
  const qLicenseId = params.get("licenseId");
  const qTabId = params.get("tabId");

  // State ile gelenler (create sonrası navigate ile yollarsan)
  const sLicenseId = location.state?.licenseId;
  const sTabId = location.state?.tabId;

  // Storage fallback (refresh olursa)
  const storedLicenseId =
    typeof window !== "undefined"
      ? sessionStorage.getItem(STORAGE_KEY)
      : null;

  const storedTabId =
    typeof window !== "undefined"
      ? sessionStorage.getItem(STORAGE_TAB_KEY)
      : null;

  const licenseId = useMemo(() => {
    return sLicenseId ?? qLicenseId ?? storedLicenseId ?? null;
  }, [sLicenseId, qLicenseId, storedLicenseId]);

  const tabId = useMemo(() => {
    return sTabId ?? qTabId ?? storedTabId ?? null;
  }, [sTabId, qTabId, storedTabId]);

  useEffect(() => {

    if (licenseId) sessionStorage.setItem(STORAGE_KEY, String(licenseId));
    if (tabId) sessionStorage.setItem(STORAGE_TAB_KEY, String(tabId));

    if (typeof window !== "undefined") {
      const desired = "/";
      if (window.location.pathname !== desired) {
        window.history.replaceState(window.history.state, "", desired);
      } else {
        if (window.location.search) {
          window.history.replaceState(window.history.state, "", desired);
        }
      }
    }
  }, [licenseId, tabId]);

  if (!licenseId) return null;

  return <EditLicence id={Number(licenseId)} tabId={tabId} />;
};

export default AdminLicensePage;
